<template>

  <div class="wrapper">

    <v-sidebar activeNavItem="shipment"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'Shipments'" v-bind:path="'/shipment'"></v-navbar>

      <div class="content">
        <div class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                <div class="card data-tables">
                  <div class="card-body table-no-bordered dataTable dtr-inline table-full-width">
                    <div class="toolbar">
                      <!-- Here you can write extra buttons/actions for the toolbar -->
                    </div>
                    <div class="fresh-datatables">
                      <table id="datatables" class="table table-condensed" cellspacing="0" width="100%" style="width:100%">
                        <thead>
                          <tr>
                            <th>Customer</th>
                            <th>TO #</th>
                            <th>Pick Up Date</th>
                            <th>Delivery Date</th>
                            <th>Status</th>
                            <th class="disabled-sorting text-right">Actions</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <v-footer></v-footer>

    </div>

  </div>


</template>

<script>
import apiService from '../../services/api.service'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'

var rows = [];
var myQuotes = {};


export default {
  name: 'ShipmentView',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer
  },
  mounted () {
    this.refreshList();
  }, // end mounted


  methods: {
    refreshList: async function () {
      var vm = this;

      if(rows.length > 0 && sessionStorage.refreshAwarded != "true") {
        initDataTable();
        return;
      }

      // Remove old rows from table
      sessionStorage.refreshAwarded = "false";
      var rowlen = rows.length
      for (var j = 0; j < rowlen; j++) {
        rows.pop()
      }

      // Get a list of all RFQs
      const response = await apiService.get('/kong/api/v1/rfq/');

      // Successfully got a complete list, parse and add to the model
      for (var i = 0; i < response.data.Result.length; i++) {

        var rel = response.data.Result[i]

        var lastUpdated = new Date(rel.updatedAt);
        var lastViewedDate = localStorage["lastViewedDate"+rel.id+localStorage.getItem('local_id')];
        if (lastViewedDate == null) lastViewedDate = new Date("2001-01-01 00:00:00");

        const muted = "<span class='text-muted'>"
        const mutedend = "</span>"

        var bold = "";
        var boldend = "";
        if (lastViewedDate < lastUpdated) {
          bold = "<b>";
          boldend = "</b>";
        }

        var combinedId = rel.customerid ? rel.id + "." + rel.customerid : rel.id;

        const dispatchStatus = (status) => {
          if(!status) return "Pending";
          if(status === "PickedUp") return "Picked Up";
          return status;
        }

        const dispatchDataLink = (status) => `<a href="#/shipment/tracking/${combinedId}" class="btn btn-link btn-info" style="margin-left: -3px">${dispatchStatus(status)}</a>`;

        var rfqCard = {
          "id": rel.id,
          "combinedId": combinedId,
          "customer": bold + rel.customer + "<br>" + "<small class='text-muted'>" + rel.id + "</small>" + boldend,
          "customertransferorder": bold + rel.customerTransferOrder || "" + boldend,
          "actions": '<a href="#/shipment/view/' + combinedId + '" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a>',
          "status": rel.dispatchStatus === "Delivered" || rel.dispatchStatus === "PickedUp"? dispatchDataLink(rel.dispatchStatus): (bold + dispatchStatus(rel.dispatchStatus) + boldend)
        }

        if (rel.securitylevel == "Creator") {
          rfqCard.actions += '<a onclick="confirmDeleteRFQ(\'' + combinedId + '\')" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>';
        }
        else {
          rfqCard.actions += '<a class="btn btn-link" disabled><i class="fa fa-fw fa-trash"></i></a>';
        }

        var isDuplicate = false;
        var isAwarded = false;
        if (rel.assignees != null) {
          for (var j = 0; j < rel.assignees.length; j++) {
            if (rel.assignees[j].quote != null) {
              if (rel.assignees[j].quote.status == 'Awarded') {
                const pickupDateTime = safeDate(rel.assignees[j].quote.pickupdate, rel.assignees[j].quote.pickupDateTime)
                const pickupDate = serverTimeToLocalFormat(pickupDateTime, "yyyy-mm-dd");
                const pickupHour = serverTimeToLocalFormat(pickupDateTime, "HH:MM");

                const deliveryDateTime = safeDate(rel.assignees[j].quote.deliverydate, rel.assignees[j].quote.deliveryDateTime)
                const deliveryDate = serverTimeToLocalFormat(deliveryDateTime, "yyyy-mm-dd");
                const deliveryHour = serverTimeToLocalFormat(deliveryDateTime, "HH:MM");

                rfqCard.pickupdate = bold + pickupDate + "   " + boldend + muted + pickupHour + mutedend;
                rfqCard.deliverydate = bold + deliveryDate + "   " + boldend + muted + deliveryHour + mutedend;
                isAwarded = true;
              }
            }

            if (rel.assignees[j].assignerid == rel.assignees[j].assigneeid && rel.securitylevel != "Creator") {
              // when we assign to ourselves don't show the RFQ twice. Just show the Creator version
              isDuplicate = true;
            }
          }
        }

        if (!isDuplicate && isAwarded) rows.push(rfqCard);
      }

      // this is not ideal for passing data.. need to swap out Datatables for something that is Vue friendly
      sessionStorage.awardedData = JSON.stringify(rows);

      sessionStorage.num_shippments = " ("+rows.length+")";
      document.getElementById("num_shippments").innerHTML = sessionStorage.num_shippments;

      initDataTable();
    }
  }
}

function initDataTable() {
  var vm = this;
  var mytable = $('#datatables').DataTable({
    "data": rows,
    "columns": [
      { "data": "customer" },
      { "data": "customertransferorder", "width": "90px" },
      { "data": "pickupdate" },
      { "data": "deliverydate" },
      { "data": "status" },
      { "data": "actions", "className": 'text-right' },
    ],
    "order": [[ 3, "desc" ]],
    "pagingType": "full_numbers",
    "lengthMenu": [
      [10, 25, 50, -1],
      [10, 25, 50, "All"]
    ],
    stateSave: false,
    retrieve: true,
    responsive: {
      details: false
    },
    language: {
      search: "_INPUT_",
      searchPlaceholder: "Search records",
    }
  });
}
</script>



// WEBPACK FOOTER //
// ShipmentView.vue?7f112715